const determinationTypes = Object.freeze({
  UnSet: 0,
  BuyingService: 1,
  Refund: 2,
  DirectPayment: 3,
});

export default determinationTypes;
